<div fxLayout="row" style="padding: 20px 10px 20px 10px;">
    <div class="center-vertical" fxFlex="20%">
        <p>Total: {{this.showedRows.length}} sur {{totalRows}}</p>
    </div>
    <div class="center-vertical" fxFlex="40%" fxLayoutAlign="center center">
        <button type="button" class="button-secondary-small" (click)="rawSetting()"  style="white-space: nowrap; align-items: center; display: flex; margin-right: 3px;">
            <mat-icon fontIcon="settings" style="color: gray; cursor: pointer; margin-right: 5px; font-size: 20px; width: fit-content; height: fit-content;"></mat-icon>
            <div>Contents Setting</div>
        </button>
    </div>
    <div class="center-vertical" fxFlex="40%" style="display: flex; align-items: center;">
        <div style="margin-left: auto;">
            <input class="col-input"  (keyup)="applyFilterLocal($event.target, 'all_column')" placeholder="Search">
        </div>
    </div>
</div>
<div class="table_div" style="height: calc(100% - 100px);">
    <div class="nav-preview" fxLayout="row" fxLayoutAlign="center center" style="float: bottom; position: absolute;">
        <mat-icon [ngClass]="navIndex === 0 ? 'nav-inactive' : 'nav-active'"style="padding: 0px 14px 0px 0px; font-size: 40px; height: 40px;" fontIcon="arrow_left" title="Previous" (click)="movePrevNextNavigation('prev')"></mat-icon>
        <span style="font-weight: bold;"> Nav {{ navIndex *  this.filterData.limit}} / {{ totalRows}}</span>
        <mat-icon [ngClass]="navIndex === totalNavigations - 1 ? 'nav-inactive' : 'nav-active'" style="padding-right: 10px; font-size: 40px; height: 40px;" fontIcon="arrow_right" title="Next" (click)="movePrevNextNavigation('next')"></mat-icon>
    </div>
    <table>
        <thead>
            <tr>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'id', 'number')"></mat-icon>
                    <div class="column-name">Id Content</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'id')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'supplier', 'string')"></mat-icon>
                    <div class="column-name">Supplier</div>
                    <mat-select placeholder="Choose" style="height: 22px; max-width: 150px;" (selectionChange)="applyFilterLocal($event, 'supplier')">
                        <mat-option [value]="''">ALL</mat-option>
                        <mat-option [value]="el" *ngFor="let el of suppliers">{{el}}</mat-option>
                    </mat-select>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'uploader', 'string')"></mat-icon>
                    <div class="column-name">Uploader</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'uploader')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'origin_name', 'string')"></mat-icon>
                    <div class="column-name">Origin name</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'origin_name')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'size', 'string')"></mat-icon>
                    <div class="column-name">Size</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'size')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'file_name', 'string')"></mat-icon>
                    <div class="column-name">Name</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'file_name')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'total_page', 'string')"></mat-icon>
                    <div class="column-name">Page</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'total_page')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'format', 'string')"></mat-icon>
                    <div class="column-name">Format</div>
                    <mat-select placeholder="Choose" style="height: 22px;" (selectionChange)="applyFilterLocal($event, 'format')">
                        <mat-option [value]="''">ALL</mat-option>
                        <mat-option [value]="el" *ngFor="let el of formats">{{el}}</mat-option>
                    </mat-select>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'state', 'string')"></mat-icon>
                    <div class="column-name">State</div>
                    <mat-select placeholder="Choose" style="height: 22px;" (selectionChange)="applyFilterLocal($event, 'state')">
                        <mat-option [value]="''">ALL</mat-option>
                        <mat-option [value]="'raw'">Raw</mat-option>
                        <mat-option [value]="'splited'">Splited</mat-option>
                    </mat-select>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'created_date', 'date')"></mat-icon>
                    <div class="column-name">Created date</div>
                    <div><input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'created_date')"></div>
                </th>
                <th>
                    <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'id_project', 'string')"></mat-icon>
                    <div class="column-name">Project</div>
                    <mat-select placeholder="Choose" style="height: 22px;" (selectionChange)="applyFilterLocal($event, 'with_project')">
                        <mat-option [value]="''">ALL</mat-option>
                        <mat-option [value]="'yes'">With Project</mat-option>
                        <mat-option [value]="'no'">Without Project</mat-option>
                    </mat-select>
                </th>
                <th>
                    <div style="display: flex; justify-content: center;"><input #checkedAllRef type="checkbox" class="form-check-input" style="font-size:large; cursor: pointer; " [disabled]="true" (change)="selectAll($event.target)"></div>
                </th>
            </tr>
        </thead>
        <tbody #row_tbody *ngFor="let row of showedRows; let i = index">
            <tr (click)="toggleRow(row, $event.target, row_tbody)">
                <td>{{ row['id'] }}</td>
                <td matTooltip="{{ row['supplier'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['supplier'] }}</td>
                <td style="white-space: nowrap;">{{ row['uploader'] }}</td>
                <td matTooltip="{{ row['origin_name'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['origin_name'] }}</td>
                <td style="white-space: nowrap;">{{ row['size'] }}</td>
                <td matTooltip="{{ row['file_path']?.split('/')?.at(-1) ?? '' }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['file_path']?.split('/')?.at(-1) ?? ''}}</td>
                <td>{{ row['total_page'] }}</td>
                <td>{{ row['format'] }}</td>
                <td>{{ row['state'] }}</td>
                <td style="white-space: nowrap;">{{ row['created_date'] }}</td>
                <td>{{ row['id_project']}}</td>
                <td class="to_skip_element">
                    <input type="checkbox" [checked]="row['checked']" class="form-check-input" style="font-size:large; cursor: pointer; " [disabled]="row['id_project']" (change)="selectRow($event.target, i)">
                </td>
            </tr>
            <tr class="expand_detail" *ngIf="row['expanded']">
                <td colspan="13">
                    <app-pdf-viewer [userInfos]="userInfos" [pdfData]="row['pdf_data']" [pageOrigin]="'project_creation'" (callBackEvent)="callBackEvent($event)" class="pdf-container"></app-pdf-viewer>
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="showedRows.length === 0">
            <tr ><td colspan="14" style="text-align: center;">No matching records found</td></tr>
        </tbody>
    </table>
</div>